export function articleProgress() {
    const progressBar = document.querySelector('.article-progress__fill');
    if (!progressBar) return;

    document.addEventListener('scroll', () => {
        const scrollTop = window.scrollY;
        const docHeight = document.documentElement.scrollHeight - window.innerHeight;
        const scrollPercent = (scrollTop / docHeight) * 100;
        progressBar.style.width = `${scrollPercent}%`;
    });
}
